import {api} from './configs/axiosConfig';

const endPoint = "/saas-authentication";

export const identityAPI = {
    logIn : async function(userName, password, comCode){
        const response = await api.request({
            url : `${endPoint}/saas-logIn`,
            method : 'POST',
            data: { userName, password, comCode }
        })

        return response.data;
    }
}
